import ContextMenu from 'devextreme/ui/context_menu';

import CoreUtils from '../../common/utils/CoreUtils';
import ScheduleApi from '../../api-services/ScheduleApi';

import ScheduleMain from '../../schedules/ScheduleMain';
import ScheduleSelectionController from '../../schedules/controllers/ScheduleSelectionController';

import BaseFlexShapeColumnManager from './BaseFlexShapeColumnManager';
import BaseFlexShapeDataModel from './BaseFlexShapeDataModel';

export class BaseFlexShapeMain extends ScheduleMain {
  constructor(props) {
    super(props);

    this.selectionController = new ScheduleSelectionController(
      BaseFlexShapeDataModel.scheduleIdProperty,
      BaseFlexShapeDataModel.enableEditProperty,
      this.dataGridRef,
      this.isAltRowIndex,
      this.toolTipDelayMs,
      this.onSelectionControllerQuerySelectableRow.bind(this),
      this.onSelectionControllerCancelPopups.bind(this),
      this.onSelectionControllerShowFieldTooltip.bind(this),
      this.onSelectionControlleronHideFieldTooltip.bind(this)
    );

    this.dataModel = new BaseFlexShapeDataModel(
      this.locale,
      this.counterparty,
      this.commandDataModel
    );

    this.columnManager = new BaseFlexShapeColumnManager(
      this.session,
      this.counterparty
    );
    this.columnManager.settings.loadColumnSettings();
  }

  async loadGridValues() {
    this.closePopOutEditor();
    this.selectionController.clearCurrentSelection();

    var scheduleUpdateDto = await ScheduleApi.getFullUpdate(
      this.counterparty.code,
      this.commandDataModel.currentMonth
    );

    this.dataModel.processFullServerUpdate(scheduleUpdateDto);
    this.dataModel.setActivateEnergyElection(true);

    this.selectionController.setEnableSelection(this.dataModel.isEditingEnabled);
    this.selectionController.setActivateSelection(true);

    this.commandDataModel.updateProperties({
      isEditingEnabled: this.dataModel.isEditingEnabled,
      canUserManageColumnPreferences: scheduleUpdateDto.canUserManageColumnPreferences,
      currentContracts: this.dataModel.contracts,
      resubmitContracts: this.dataModel.contracts.filter(contract => contract.enableResubmitValues),
      recalculateContracts: this.dataModel.contracts.filter(contract => contract.enableRecalculateValues)
    });
  }

  async updateGridValues(lastRetrievalTimeUtc) {
    var scheduleUpdateDto = await ScheduleApi.getPartialUpdate(
      this.counterparty.code,
      this.commandDataModel.currentMonth,
      lastRetrievalTimeUtc
    );

    this.dataModel.processBackgroundServerUpdate(scheduleUpdateDto);
  }

  submitGridChanges(onSubmitFinished) {
    this.closePopOutEditor();
    this.selectionController.clearCurrentSelection();

    var dateSubmissions = this.dataModel.getCurrentModifications();
    ScheduleApi.submitChanges(
      this.counterparty.code,
      dateSubmissions,
      onSubmitFinished,
      false
    );
  }

  revertGridChanges() {
    this.closePopOutEditor();
    this.selectionController.clearCurrentSelection();
    this.dataModel.revertCurrentModifications();
  }

  onViewKeyDown(event) {
    super.onViewKeyDown(event);

    if (event.key === 'Escape') {
      this.closePopOutEditor();
      this.selectionController.clearCurrentSelection();
    }
  }

  updateCellAppearance(schedule, dataField, isAltRow, element) {
    if (CoreUtils.isDefinedAndNotNull(schedule))
      this.selectionController.updateCellAppearance(schedule.scheduleId, dataField, isAltRow, element);

    super.updateCellAppearance(schedule, dataField, isAltRow, element);
  }

  onDataGridCellHoverChanged(event) {
    this.selectionController.onCellHoverChanged(event);
  }

  onDataGridEditingStart(event) {
    super.onDataGridEditingStart(event);

    if (!event.cancel)
      this.selectionController.clearCurrentSelection();
  }

  onDataGridKeyDown(event) {
    if (event.event.code === 'Escape') {
      this.closePopOutEditor();
      this.selectionController.clearCurrentSelection();
    }
  }

  onDataGridContextMenuPreparing(event) {
    if (event.target !== 'content')
      return;

    var disabled = true;
    if (event.row !== undefined && this.selectionController.enableSelection && this.selectionController.activateSelection) {
      disabled = !this.selectionController.isCellSelected(event.row.key, event.column.dataField);

      if (disabled) {
        this.selectionController.selectCurrentCell();
        disabled = !this.selectionController.isCellSelected(event.row.key, event.column.dataField);
      }
    }

    if (disabled) {
      event.items = [];
      return;
    }

    event.items = [{
      text: 'Add Base Hours',
      icon: 'plus',
      disabled: disabled,
      onItemClick: this.onBaseFlexShapeMenuCommand.bind(this),
      addBaseHours: true
    }, {
      text: 'Remove Base Hours',
      icon: 'minus',
      disabled: disabled,
      onItemClick: this.onBaseFlexShapeMenuCommand.bind(this),
      addBaseHours: false
    }];
  }

  onBaseFlexShapeMenuCommand(event) {
    var updateCount = this.dataModel.toggleBaseEnergyValues(
      this.selectionController.getCurrentSelection(),
      event.itemData.addBaseHours
    );

    if (updateCount > 0)
      this.selectionController.clearCurrentSelection();
  }

  onSelectionControllerQuerySelectableRow(event) {
    return this.dataModel.canSelectRow(event.scheduleId);
  }

  onSelectionControllerCancelPopups(event) {
    var contextMenus = document.getElementsByClassName('dx-context-menu');
    for (var index = 0; index < contextMenus.length; index++) {
      var contextMenu = ContextMenu.getInstance(contextMenus[index]);
      if (CoreUtils.isDefinedAndNotNull(contextMenu))
        contextMenu.hide();
    };
  }

  onSelectionControllerShowFieldTooltip(event) {
    var dataGrid = this.resolveDataGrid();
    if (dataGrid !== null && dataGrid.getController('editing').isEditing())
      return false;

    return this.onShowDataGridToolTip(
      event.element,
      this.dataModel.resolveScheduleById(event.scheduleId),
      event.dataField
    );
  }

  onSelectionControlleronHideFieldTooltip(event) {
    this.toolTipController.deactivate();
  }
}
